import { createAction, props } from '@ngrx/store';
import { Country } from '@qvs/core';
import { createLoadingStatusActionGroup } from '~/shared/helpers/loading-status-helper';

const prefix = '[Countries]';

export const {
  load: loadCountries,
  success: loadCountriesSuccess,
  failure: loadCountriesFailure
} = createLoadingStatusActionGroup(prefix, 'countries');

export const loadCountriesOnlyIfNotLoadedYet = createAction(`${prefix} load countries only if not loaded yet`);

export const upsertCountries = createAction(`${prefix} upsert countries`, props<{ entities: Country[] }>());
